import React from 'react';
import Icon from '@components/AppIcon';

const AboutHero = () => {
  return (
    <section
  className="relative pt-28 pb-20 md:pt-32 md:pb-28 min-h-[480px] flex items-center"
  style={{
    backgroundImage: `url('/storage/gallery_images/slider-3.png')`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  }}
>
  {/* Blue overlay */}
  <div className="absolute inset-0 bg-blue-900/70"></div>

  <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
    {/* Headline */}
    <h1 className="font-heading font-bold text-4xl md:text-5xl lg:text-6xl text-white mb-6 drop-shadow-lg">
      Making Your Vision <span className="text-white ">Our Mission</span>
    </h1>

    {/* Subheading */}
    <p className="text-lg md:text-xl lg:text-2xl text-white/95 mb-10 leading-relaxed drop-shadow-md max-w-3xl mx-auto">
      Compassionate care, innovative solutions, and a commitment to healthier vision for everyone.
    </p>

    {/* Values Row */}
    <div className="flex flex-col sm:flex-row items-center justify-center gap-6 text-white/90">
      <div className="flex items-center gap-2 text-lg font-medium">
        <Icon name="Heart" size={22} className="text-[#eb2227]" />
        <span>Driven by Compassion</span>
      </div>
      <div className="flex items-center gap-2 text-lg font-medium">
        <Icon name="Eye" size={22} className="text-[#eb2227]" />
        <span>Vision for All</span>
      </div>
      <div className="flex items-center gap-2 text-lg font-medium">
        <Icon name="Activity" size={22} className="text-[#eb2227]" />
        <span>Empowering Communities</span>
      </div>
    </div>
  </div>
</section>


  );
};

export default AboutHero;
